import React from 'react';
import { CTAButton } from './CTAButton';
import { features } from '../data/content';
import { OFFER_ANCHOR } from '../data/constants';
export function WhatYouGet() {
  return <section className="border-b border-steelLine bg-charcoal px-4 py-8 sm:py-10" data-id="element-153" data-mp="l3ctmrh1e1u7">
      <div className="mx-auto max-w-5xl" data-id="element-154" data-mp="l5pjdqt1dght">
        <p className="text-center font-display text-[0.65rem] font-bold uppercase tracking-[0.22em] text-gold sm:text-xs" data-id="element-155" data-mp="q1mp736ob4gc">
          What You Get
        </p>
        <h2 className="mt-1.5 text-center text-xl text-white sm:text-3xl" data-id="element-156" data-mp="1ducy13ja57me">
          Everything Inside <span className="text-gold" data-id="element-157" data-mp="1it6ft85lnksd">Metal Fabrication Ready™</span>
        </h2>
        <ul className="mt-4 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-158" data-mp="141xfo542mh0z">
          {features.map(feature => <li key={feature.title} className="flex h-full flex-col rounded-md border border-steelLine bg-steel p-3.5" data-id="element-159" data-mp="18z7cw6xpbwzd">
              <h3 className="flex items-center gap-2 text-sm text-white sm:text-base" data-id="element-160" data-mp="21imncffpcdia">
                <span aria-hidden="true" className="text-lg" data-id="element-161" data-mp="2vf0v59b9wo3k">
                  {feature.emoji}
                </span>
                {feature.title}
              </h3>
              <p className="mt-1.5 text-sm font-medium leading-snug text-lightGray" data-id="element-162" data-mp="355nar3izpem9">{feature.body}</p>
            </li>)}
        </ul>
        <div className="mx-auto mt-4 max-w-md" data-id="element-163" data-mp="30e55w4duitw0">
          <CTAButton href={OFFER_ANCHOR} data-id="element-164" data-mp="3e6bm1qh010vg">🔥 Get Instant Access</CTAButton>
        </div>
      </div>
    </section>;
}